import { Route, Routes } from "react-router-dom";
import FormacionDocente from "../newPages/homenew/FormacionDocente";
import MaestriaAnalisisBiologico from "../newPages/posgradosnew/MaestriaAnalisisBiologico";
import EspecializacionAnestesiologia from "../newPages/posgradosnew/EspecializacionAnestesiologia";
import EspecializacionImagenologia from "../newPages/posgradosnew/EspecializacionImagenologia";
import MaestriaGerenciaSalud from "../newPages/posgradosnew/MaestriaGerenciaSalud";
import MaestriaGestionCalidad from "../newPages/posgradosnew/MaestriaGestionCalidad";
import EspecializacionMedicina from "../newPages/posgradosnew/EspecializacionMedicina";
import PresencialHorarios from "../newPages/homenew/PresencialHorarios";
import PresencialResultados from "../newPages/homenew/PresencialResultados";
import MaestriaCienciasAmbientales from "../newPages/posgradosnew/MaestriaCienciasAmbientales";
import MaestriaProduccion from "../newPages/posgradosnew/MaestriaProduccion";
import MaestriaAuditoria from "../newPages/posgradosnew/MaestriaAuditoria";
import MaestriaGestionAlimentos from "../newPages/posgradosnew/MaestriaGestionAlimentos";
import MaestriaGestionFinanciera from "../newPages/posgradosnew/MaestriaGestionFinanciera";
import EspecializacionTributacion from "../newPages/posgradosnew/EspecializacionTributacion";
import MaestriaRecursosNaturales from "../newPages/posgradosnew/MaestriaRecursosNaturales";
import MaestriaBioeconomia from "../newPages/posgradosnew/MaestriaBioeconomia";
import MaestriaCienciasQuimicas from "../newPages/posgradosnew/MaestriaCienciasQuimicas";
import MaestriaFarmaciaAsistencial from "../newPages/posgradosnew/MaestriaFarmaciaAsistencial";
import MaestriaSeguridadIndustrial from "../newPages/posgradosnew/MaestriaSeguridadIndustrial";
import MaestriaCienciasPoliticas from "../newPages/posgradosnew/MaestriaCienciasPoliticas";
import MaestriaCrimonologia from "../newPages/posgradosnew/MaestriaCrimilogia";
import MaestriaDerechoConstitucional from "../newPages/posgradosnew/MaestriaDerechoConstitucional";
import MaestriaDerechoProcesal from "../newPages/posgradosnew/MaestriaDerechoProcesal";
import MaestriaDerechoProcesalPenal from "../newPages/posgradosnew/MaestriaDerechoProcesalPenal";
import MaestriaDerechoProcesalAdministrativo from "../newPages/posgradosnew/MaestriaDerechoProcesalAdministrativo";
import MaestriaDerechoTributario from "../newPages/posgradosnew/MaestriaDerechoTributario";
import MaestriaComunicacionIA from "../newPages/posgradosnew/MaestriaComunicacionIA";
import MaestriaEducacionMatematica from "../newPages/posgradosnew/MaestriaEducacionMatematica";
import MaestriaPedagogiaIdiomas from "../newPages/posgradosnew/MaestriaPedagogiaIdiomas";
import MaestriaPedagogiaArtes from "../newPages/posgradosnew/MaestriaPedagogiaArtes";
import MaestriaComunicacionEstrategica from "../newPages/posgradosnew/MaestriaComunicacionEstrategica";
import MaestriaEducacionInclusiva from "../newPages/posgradosnew/MaestriaEducacionInclusiva";
import MaestriaLiteratura from "../newPages/posgradosnew/MaestriaLiteratura";
import MaestriaInvestigacionEducacion from "../newPages/posgradosnew/MaestriaInvestigacionEducacion";
import MaestriaEducacionFamiliarEducativa from "../newPages/posgradosnew/MaestriaEducacionFamiliarEducativa";
import MaestriaGestionAprendizaje from "../newPages/posgradosnew/MaestriaGestionAprendizaje";
import MaestriaEducacionInnovacion from "../newPages/posgradosnew/MaestriaEducacionInnovacion";
import MaestriaEducacionCurriculo from "../newPages/posgradosnew/MaestriaEducacionCurriculo";
import EspecializacionGeotecnia from "../newPages/posgradosnew/EspecializacionGeotecnia";
import EspecializacionGeoinformacion from "../newPages/posgradosnew/EspecializacionGeoinformacion";
import EspecializacionAlcantarillado from "../newPages/posgradosnew/EspecializacionAlcantarillado";

function NewRoutes() {
  return (
    <>
      <Routes>
        {" "}
        <Route
          path="/formacion-docente"
          element={<FormacionDocente></FormacionDocente>}
        />{" "}
        <Route
          path="/horarios-prueba-admision"
          element={<PresencialHorarios></PresencialHorarios>}
        />
        <Route
          path="/resultados-prueba-admision"
          element={<PresencialResultados />}
        />
        {/* Posgrados*/}
        <Route
          path="/maestria-analisis-biologico"
          element={<MaestriaAnalisisBiologico />}
        />
        <Route
          path="/maestria-gerencia-salud"
          element={<MaestriaGerenciaSalud />}
        />
        <Route
          path="/maestria-gestion-calidad"
          element={<MaestriaGestionCalidad />}
        />
        <Route
          path="/maestria-ciencias-ambientales"
          element={<MaestriaCienciasAmbientales />}
        />
        <Route path="/maestria-produccion" element={<MaestriaProduccion />} />
        <Route path="/maestria-auditoria" element={<MaestriaAuditoria />} />
        <Route
          path="/maestria-gestion-alimentos"
          element={<MaestriaGestionAlimentos />}
        />
        <Route
          path="/maestria-gestion-financiera"
          element={<MaestriaGestionFinanciera></MaestriaGestionFinanciera>}
        />
        <Route
          path="/maestria-recursos-naturales"
          element={<MaestriaRecursosNaturales />}
        />
        <Route path="/maestria-bioeconomia" element={<MaestriaBioeconomia />} />
        <Route
          path="/maestria-ciencias-quimicas"
          element={<MaestriaCienciasQuimicas />}
        />
        <Route
          path="/maestria-farmacia-asistencial"
          element={<MaestriaFarmaciaAsistencial />}
        />
        <Route
          path="/maestria-seguridad-industrial"
          element={<MaestriaSeguridadIndustrial />}
        />
        <Route
          path="/especializacion-anestesiologia"
          element={<EspecializacionAnestesiologia />}
        />
        <Route
          path="/especializacion-imagenologia"
          element={<EspecializacionImagenologia />}
        />
        <Route
          path="/especializacion-medicina-familiar"
          element={<EspecializacionMedicina />}
        />
        <Route
          path="/especializacion-tributacion"
          element={<EspecializacionTributacion />}
        />
        <Route
          path="/maestria-ciencias-politicas"
          element={<MaestriaCienciasPoliticas></MaestriaCienciasPoliticas>}
        />
        <Route
          path="/maestria-derecho-constitucional"
          element={
            <MaestriaDerechoConstitucional></MaestriaDerechoConstitucional>
          }
        />
        <Route
          path="/maestria-criminologia"
          element={<MaestriaCrimonologia></MaestriaCrimonologia>}
        />
        <Route
          path="/maestria-derecho-procesal"
          element={<MaestriaDerechoProcesal />}
        />
        <Route
          path="/maestria-derecho-procesal-penal"
          element={<MaestriaDerechoProcesalPenal />}
        />
        <Route
          path="/maestria-derecho-procesal-administrativo"
          element={<MaestriaDerechoProcesalAdministrativo />}
        />
        <Route
          path="/maestria-derecho-tributario"
          element={<MaestriaDerechoTributario />}
        />
        <Route
          path="/maestria-comunicacion-ia"
          element={<MaestriaComunicacionIA />}
        />
        <Route
          path="/maestria-educacion-matematica"
          element={<MaestriaEducacionMatematica />}
        />
        <Route
          path="/maestria-pedagogia-idiomas"
          element={<MaestriaPedagogiaIdiomas />}
        />
        <Route
          path="/maestria-pedagogia-artes"
          element={<MaestriaPedagogiaArtes />}
        />
        <Route
          path="/maestria-comunicacion-estrategica"
          element={<MaestriaComunicacionEstrategica />}
        />
        <Route
          path="/maestria-educacion-inclusiva"
          element={<MaestriaEducacionInclusiva />}
        />
        <Route path="/maestria-literatura" element={<MaestriaLiteratura />} />
        <Route
          path="/maestria-investigacion-educacion"
          element={<MaestriaInvestigacionEducacion />}
        />
        <Route
          path="/maestria-educacion-familiar-educativa"
          element={<MaestriaEducacionFamiliarEducativa />}
        />
        <Route
          path="/maestria-gestion-aprendizaje-tic"
          element={<MaestriaGestionAprendizaje />}
        />
        <Route
          path="/maestria-educacion-innovacion"
          element={<MaestriaEducacionInnovacion />}
        />
        <Route
          path="/maestria-educacion-curriculo"
          element={<MaestriaEducacionCurriculo />}
        />
        <Route
          path="/especializacion-geotecnia"
          element={<EspecializacionGeotecnia />}
        />
        <Route
          path="/especializacion-geoinformacion"
          element={<EspecializacionGeoinformacion />}
        />
        <Route
          path="/especializacion-alcantarillado"
          element={<EspecializacionAlcantarillado />}
        />
      </Routes>
    </>
  );
}

export default NewRoutes;
